// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"Feedback-module--subtitle--2rsol","social":"Feedback-module--social--YJY1V","title":"Feedback-module--title--1G8SM"};